import axios from 'axios';

// declares the axios instance to be used for letrusAPI communication
const networkStatusClient = axios.create({
  timeout: 360 * 1000,
  baseURL: window.location.origin,
});

// create Network status interceptor to find out if the APP is online
networkStatusClient.interceptors.response.use(
  (response) => {
    window.dispatchEvent(new CustomEvent('networkStatus', {detail: 'online'}));
    return response;
  },
  (error) => {
    if (error?.message === 'Network Error') {
      window.dispatchEvent(
        new CustomEvent('networkStatus', {detail: 'offline'}),
      );
    }
    return Promise.reject(error);
  },
);

// returns a configured axios instance,  bearing the correct auth token
function networkStatusAPI(url: string) {
  return networkStatusClient({
    url,
    method: 'HEAD',
  });
}

export default networkStatusAPI;
